import { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Button } from "../../common/Button";

/**
 * Edit modal for long AI agent text assets (system prompt / red flags).
 * Draft is local until Apply; parent formik is updated on Apply only.
 */
const AgentPromptEditModal = ({
  show,
  onHide,
  title,
  value = "",
  placeholder = "",
  defaultButtonLabel = "Load Default",
  onApply,
  onLoadDefault,
  loadingDefault = false,
}) => {
  const [draft, setDraft] = useState(value || "");

  useEffect(() => {
    if (show) {
      setDraft(value || "");
    }
  }, [show, value]);

  const handleApply = () => {
    onApply?.(draft);
    onHide?.();
  };

  const handleLoadDefault = async () => {
    if (!onLoadDefault) return;
    const text = await onLoadDefault();
    if (typeof text === "string") {
      setDraft(text);
    }
  };

  return (
    <Modal
      backdrop="static"
      show={show}
      onHide={onHide}
      size="xl"
      aria-labelledby="agent-prompt-edit-modal-title"
      centered
      className="custom-dialog"
    >
      <Modal.Header closeButton className="border-0">
        <Modal.Title id="agent-prompt-edit-modal-title">{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="d-flex justify-content-end mb-3">
          <Button
            type="button"
            variant="secondary"
            onClick={handleLoadDefault}
            disabled={loadingDefault || !onLoadDefault}
          >
            {loadingDefault ? "Loading..." : defaultButtonLabel}
          </Button>
        </div>
        <textarea
          className="form-control"
          value={draft}
          onChange={(e) => setDraft(e.target.value)}
          placeholder={placeholder}
          rows={22}
          style={{
            fontFamily: "monospace",
            fontSize: 14,
            minHeight: "55vh",
            resize: "vertical",
          }}
        />
        <div
          className="d-flex justify-content-end mt-3"
          style={{ gap: 8 }}
        >
          <Button type="button" variant="secondary" onClick={onHide}>
            Cancel
          </Button>
          <Button type="button" onClick={handleApply}>
            Apply
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default AgentPromptEditModal;
